import { useLocation } from "react-router";

export type CurrentView = "grading" | "reader" | "rubric";

export const useCurrentView = (): CurrentView => {
  const location = useLocation();

  if (location.pathname.includes("/grading")) {
    return "grading";
  } 

  if (location.pathname.includes("/rubric")) {
    return "rubric";
  } 

  return "reader";
}